import Error404 from "@JohnLewisPartnership/jl-design-system/dist/components/error-404/Error404";
import Error500 from "@JohnLewisPartnership/jl-design-system/dist/components/error-500/Error500";

export { Error404, Error500 };
